/** The address and theme hand-over between the back office and its ComDesk frame. */

const PREFIX = "/admin/comdesk/";

/** `#mail/abc` for `/admin/comdesk/mail/abc`. */
export function hashFor(pathname: string): string {
  const rest = pathname.startsWith(PREFIX) ? pathname.slice(PREFIX.length) : "";
  return `#${rest.replace(/\/+$/, "") || "dashboard"}`;
}

/** `/admin/comdesk/mail/abc` for `#mail/abc`; null for anything else. */
export function pathFor(hash: unknown): string | null {
  if (typeof hash !== "string" || !/^#[A-Za-z0-9/_-]+$/.test(hash)) return null;
  return PREFIX + hash.slice(1);
}

/** HealthPass's palette in ComDesk's token names (ComDesk ui/src/hostTheme.ts). */
export function hostTheme(root: HTMLElement = document.documentElement) {
  const css = getComputedStyle(root);
  const raw = (name: string) => css.getPropertyValue(name).trim();
  // Tailwind's semantic colours are stored as RGB channels ("51 36 214").
  const rgb = (name: string) => (raw(name) ? `rgb(${raw(name)})` : "");
  return {
    scheme: root.classList.contains("dark") ? "dark" : "light",
    tokens: {
      bg: raw("--ground") || raw("--color-bg"),
      surface: raw("--surface"),
      border: rgb("--border"),
      text: raw("--color-fg"),
      muted: rgb("--muted-foreground"),
      accent: rgb("--primary"),
      "accent-text": rgb("--primary-foreground"),
      radius: raw("--radius"),
      font: raw("--font-sans"),
    },
  };
}
